import dagre from 'dagre-d3';
import * as d3 from 'd3';

export const defaultNodeOptions = {
    rx: 5,
    ry: 5
};

export const getTransitionMarkup = tr => {
    return `<div class="flow-transition-label">
            ${tr.action_text.eng}
        </div>`;
};

export const getTransitionOptions = tr => {
    return {
        labelType: 'html',
        label: getTransitionMarkup(tr),
        curve: d3.curveBasis,
        labelpos: 'c'
    };
};

export const createGraph = (selector, transitions, states, flow) => {
    const graph = new dagre.graphlib.Graph().setGraph({});

    states.forEach(state => {
        if (!graph.nodes().includes(state.slug)) {
            const isInitial = state.slug === flow.initial_state.slug;

            graph.setNode(state.slug, {
                label: state.slug,
                style: isInitial ? 'fill: #93e18c' : '',
                ...defaultNodeOptions
            });
        }
    });

    transitions.forEach(tr => {
        if (tr.source_state && graph.nodes) {
            graph.setEdge(
                tr.source_state.slug,
                tr.destination_state.slug,
                getTransitionOptions(tr)
            );
        }
    });

    dagre.dagre.layout(graph);

    const svg = d3.select(selector),
        inner = svg.append('g');

    const render = new dagre.render();

    render(inner, graph);

    centerGraph(graph, svg, inner);
};

const centerGraph = (graph, svg, inner) => {
    const offset = (svg.attr('width') - graph.graph().width) / 2;
    inner.attr('transform', 'translate(' + offset + ', 20)');
    svg.attr('height', graph.graph().height + 40);
};
